var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ellipse_arrow",
    x: 0,
    y: 0,
    width: 102,
    height: 102,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6406",
    "data-name": "Group 6406",
    transform: "translate(9 5.856)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -5.86)",
    filter: "url(#ellipse_arrow)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "ellipse_arrow-2",
    "data-name": "ellipse_arrow",
    cx: 42,
    cy: 42,
    r: 42,
    transform: "translate(9 6)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "nav_arrow",
    d: "M1.021,23.456,18.475,41.207c1.8,1.787,4.51.173,4.51-2.766V32.5c0-1.9.992-3.573,2.481-3.573H36.525c1.488,0,2.706-1.383,2.706-3.343V16.252c0-1.844-1.218-3.458-2.706-3.458H25.465c-1.488,0-2.481-1.5-2.481-3.4V3.457c0-2.882-2.706-4.5-4.465-2.709L1.111,18.038A3.976,3.976,0,0,0,1.021,23.456Z",
    transform: "translate(22.251 21.095)",
    fill: "#51aabc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavArrow);
export default __webpack_public_path__ + "static/media/nav-arrow.512ea4ae.svg";
export { ForwardRef as ReactComponent };